import React, { useState, useEffect } from "react";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import Widget from "./Widgets";
import BestSellingProducts from "./BestSellingProducts";
import RecentActivity from "./RecentActivity";
import RecentOrders from "./RecentOrders";
/* import Revenue from "./Revenue"; */
import SalesByLocations from "./SalesByLocations";
import Section from "./Section";
import StoreVisits from "./StoreVisits";
import TopSellers from "./TopSellers";
import Grafica from "./Grafica";
import ComparativaProveedores from "./ComparativaProveedores";
import SolicitudesActivas from "./SolicitudesActivas";
import SolicitudesProximoMes from "./SolicitudesProximoMes";
import SolicitudesHistoricas from "./SolicitudesHistoricas";
import HistoricalWidgets from "./HistoricalWidgets";
import PromedioFacturacion from "./PromedioFacturacion";
import SolicitudesCreadas from "./SolicitudesCreadas";
import DiagnosticosFarmacologicos from "./DiagnosticosFarmacologicos";
import RendimientoMotorizados from "./RendimientoMotorizados";
import { DatosSesion } from "../../Components/Common/DatosSesion";
import { useNavigate } from "react-router-dom";

// Versión limpia - 2025-03-02 19:16
const DashboardEcommerce = () => {
  document.title = "Dashboard | Farme";
  
  const nombreUsuario = DatosSesion("nombre") || "";
  const apellidoUsuario = DatosSesion("apellido") || "";
  const farmaciaId = DatosSesion("farmacia") || null;
  const perfil = DatosSesion("perfil") || "";
  const navigate = useNavigate();

  
  useEffect(() => {
    // Redirigir a los usuarios con perfil Delivery a la página de motorizado
    if (perfil.trim() === "Delivery") {
      navigate("/motorizado/");
    }
  }, [perfil, navigate]);
  
  const nombre = `${nombreUsuario} ${apellidoUsuario}`.trim();
  const [rightColumn, setRightColumn] = useState(true);
  const [fechaInicio, setFechaInicio] = useState(null);
  const [fechaFin, setFechaFin] = useState(null);
  const [proveedorSeleccionado, setProveedorSeleccionado] = useState(null);
  const [aseguradoraSeleccionada, setAseguradoraSeleccionada] = useState("MyH+");
  const [widgetsListos, setWidgetsListos] = useState(false);
  
  const toggleRightColumn = () => {
    setRightColumn(!rightColumn);
  };
  
  const esAdministrador = (perfil === "Administrador" || perfil === "MyHealth");
  
  // Marcar widgets como listos cuando tengamos todos los datos necesarios
  useEffect(() => {
    if (fechaInicio && fechaFin) {
      // Para admin, listo inmediatamente
      if (esAdministrador) {
        setWidgetsListos(true);
      } else {
        // Para proveedor, esperar a que tenga código
        if (proveedorSeleccionado !== null) {
          setWidgetsListos(true);
        }
      }
    } else {
      setWidgetsListos(false);
    }
  }, [fechaInicio, fechaFin, proveedorSeleccionado, esAdministrador]);

  // Si el perfil es Delivery, no renderizar el dashboard
  if (perfil.trim() === "Delivery") {
    return null;
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col>
              <div className="h-100">
                <Section
                  nombre={nombre}
                  farmaciaId={farmaciaId}
                  rightColumn={rightColumn}
                  toggleRightColumn={toggleRightColumn}
                  onFechasChange={(inicio, fin) => {
                    setFechaInicio(inicio);
                    setFechaFin(fin);
                  }}
                  onProveedorChange={(proveedor) => {
                    setProveedorSeleccionado(proveedor);
                  }}
                  onAseguradoraChange={(aseguradora) => {
                    setAseguradoraSeleccionada(aseguradora);
                  }}
                  proveedorSeleccionado={proveedorSeleccionado}
                  aseguradoraSeleccionada={aseguradoraSeleccionada}
                  mostrarFiltros={false}
                />
                
                {/* Filtro de Proveedor - Antes de Métricas Históricas (solo Admin) */}
                {esAdministrador && (
                  <Row className="mb-3">
                    <Col xs={12}>
                      <Section
                        nombre={nombre}
                        farmaciaId={farmaciaId}
                        rightColumn={rightColumn}
                        toggleRightColumn={toggleRightColumn}
                        onFechasChange={(inicio, fin) => {
                          setFechaInicio(inicio);
                          setFechaFin(fin);
                        }}
                        onProveedorChange={(proveedor) => {
                          setProveedorSeleccionado(proveedor);
                        }}
                        onAseguradoraChange={(aseguradora) => {
                          setAseguradoraSeleccionada(aseguradora);
                        }}
                        proveedorSeleccionado={proveedorSeleccionado}
                        aseguradoraSeleccionada={aseguradoraSeleccionada}
                        soloFiltros={true}
                        soloProveedor={true}
                      />
                    </Col>
                  </Row>
                )}
                
                {/* Orden fijo de widgets (sin drag-and-drop) */}
                
                {/* 0. Métricas Históricas (All-time) */}
                <HistoricalWidgets proveedorSeleccionado={proveedorSeleccionado} aseguradora={aseguradoraSeleccionada} />
                
                {/* 1. Solicitudes (3 cards) - NO dependen del filtro de fechas */}
                <Row>
                  <Col xl={4}>
                    <SolicitudesActivas proveedorSeleccionado={proveedorSeleccionado} aseguradora={aseguradoraSeleccionada} />
                  </Col>
                  <Col xl={4}>
                    <SolicitudesProximoMes proveedorSeleccionado={proveedorSeleccionado} aseguradora={aseguradoraSeleccionada} />
                  </Col>
                  <Col xl={4}>
                    <SolicitudesHistoricas proveedorSeleccionado={proveedorSeleccionado} aseguradora={aseguradoraSeleccionada} />
                  </Col>
                </Row>
                
                {/* Selector de Fechas - Después de solicitudes */}
                <Row className="mt-4">
                  <Col xs={12}>
                    <Section
                      nombre={nombre}
                      farmaciaId={farmaciaId}
                      rightColumn={rightColumn}
                      toggleRightColumn={toggleRightColumn}
                      onFechasChange={(inicio, fin) => {
                        setFechaInicio(inicio);
                        setFechaFin(fin);
                      }}
                      onProveedorChange={(proveedor) => {
                        setProveedorSeleccionado(proveedor);
                      }}
                      onAseguradoraChange={(aseguradora) => {
                        setAseguradoraSeleccionada(aseguradora);
                      }}
                      proveedorSeleccionado={proveedorSeleccionado}
                      aseguradoraSeleccionada={aseguradoraSeleccionada}
                      soloFiltros={true}
                      soloFechas={true}
                    />
                  </Col>
                </Row>
                
                {/* 2. Comparativa por Proveedor (solo Admin) */}
                {esAdministrador && fechaInicio && fechaFin ? (
                  <Row className="mt-4">
                    <Col xs={12}>
                      <ComparativaProveedores
                        fechaInicio={fechaInicio}
                        fechaFin={fechaFin}
                        proveedorSeleccionado={proveedorSeleccionado}
                        aseguradora={aseguradoraSeleccionada}
                      />
                    </Col>
                  </Row>
                ) : null}
                
                {/* 3. KPIs */}
                <Row className="mt-4">
                  <Widget 
                    fechaInicio={fechaInicio}
                    fechaFin={fechaFin}
                    proveedorSeleccionado={proveedorSeleccionado}
                    aseguradora={aseguradoraSeleccionada}
                  />
                </Row>
                
                {/* 4. Promedio por Factura */}
                {widgetsListos ? (
                  <Row className="mt-4">
                    <Col xs={12}>
                      <PromedioFacturacion
                        fechaInicio={fechaInicio}
                        fechaFin={fechaFin}
                        codigoProveedor={proveedorSeleccionado}
                        aseguradora={aseguradoraSeleccionada}
                      />
                    </Col>
                  </Row>
                ) : null}

                {/* 4.5. Solicitudes Creadas */}
                {widgetsListos ? (
                  <Row className="mt-4">
                    <Col xs={12}>
                      <SolicitudesCreadas
                        fechaInicio={fechaInicio}
                        fechaFin={fechaFin}
                        codigoProveedor={proveedorSeleccionado}
                        aseguradora={aseguradoraSeleccionada}
                      />
                    </Col>
                  </Row>
                ) : null}

                {/* 5. Diagnósticos Farmacológicos (Top 5) */}
                {widgetsListos ? (
                  <Row className="mt-4">
                    <Col xs={12}>
                      <DiagnosticosFarmacologicos
                        fechaInicio={fechaInicio}
                        fechaFin={fechaFin}
                        codigoProveedor={proveedorSeleccionado}
                        aseguradora={aseguradoraSeleccionada}
                      />
                    </Col>
                  </Row>
                ) : null}
                
                {/* 6. Rendimiento de Motorizados */}
                {widgetsListos ? (
                  <Row className="mt-4">
                    <Col xs={12}>
                      <RendimientoMotorizados
                        fechaInicio={fechaInicio}
                        fechaFin={fechaFin}
                        codigoProveedor={proveedorSeleccionado}
                        aseguradora={aseguradoraSeleccionada}
                      />
                    </Col>
                  </Row>
                ) : null}
                {/* <Row>
                  <Grafica />
                </Row>
                <Row>
                  <Col xl={8}>
                    <RecentOrders />
                  </Col>
                  <Col xl={4}>
                    <TopSellers />
                  </Col>
                </Row> */}
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default DashboardEcommerce;
